import { AxiosResponse, CancelToken } from 'axios';
import { awBridgeApi } from '../../Base';
import {
  BfmAggregateAnalysisRequestV1,
  BfmAggregateAnalysisResponseV1,
  BfmPortfoliosAnalysisRequestV1,
  BfmPortfoliosAnalysisResponseV1,
} from './Models';

const ANALYZE_API_TIMEOUT = 600000;

export function postAnalyzeAggregate(
  request: BfmAggregateAnalysisRequestV1,
  cancelToken?: CancelToken
): Promise<AxiosResponse<BfmAggregateAnalysisResponseV1>> {
  const path = '/v1/aggregate/analyze';
  return awBridgeApi.post<BfmAggregateAnalysisResponseV1>(path, request, {
    cancelToken,
    timeout: ANALYZE_API_TIMEOUT,
  });
}

export function postAnalyzePortfolios(
  request: BfmPortfoliosAnalysisRequestV1,
  cancelToken?: CancelToken
): Promise<AxiosResponse<BfmPortfoliosAnalysisResponseV1>> {
  const path = '/v1/portfolios/analyze';
  return awBridgeApi.post<BfmPortfoliosAnalysisResponseV1>(path, request, {
    params: { pkg: request.pkg },
    cancelToken,
    timeout: ANALYZE_API_TIMEOUT,
  });
}
